// Currency conversion rates (you can update these with real-time rates)
const EXCHANGE_RATES = {
  '£': 1.0,    // GBP base
  '$': 1.27,   // USD to GBP
  'AED': 4.66, // AED to GBP
  'KSA': 4.75  // Saudi Riyal to GBP
};

// Currency symbols
const CURRENCY_SYMBOLS = {
  '$': '$',
  '£': '£',
  'AED': 'AED',
  'KSA': 'ر.س'
};

// Convert price from GBP to selected currency
export const convertPrice = (priceGBP, targetCurrency) => {
  if (!priceGBP || !targetCurrency) return priceGBP;
  
  const rate = EXCHANGE_RATES[targetCurrency];
  if (!rate) return priceGBP;
  
  return priceGBP * rate;
};

// Convert price from selected currency to GBP
export const convertToGBP = (price, sourceCurrency) => {
  if (!price || !sourceCurrency) return price;
  
  const rate = EXCHANGE_RATES[sourceCurrency];
  if (!rate) return price;
  
  return price / rate;
};

// Format price with currency symbol
export const formatPrice = (price, currency) => {
  if (!price) return '0.00';
  
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  const convertedPrice = convertPrice(price, currency);
  
  return `${symbol}${convertedPrice.toFixed(2)}`;
};

// Get currency symbol
export const getCurrencySymbol = (currency) => {
  return CURRENCY_SYMBOLS[currency] || currency;
}; 